import styled from"@emotion/styled";import{css}from"@emotion/react";import{WpAlert}from"@wp/src/components/common";import Button from"@wp/src/components/common/button";import{FlexLayout,mediaQuery}from"../../common/grid";import{BOTTOM_NAVIGATOR_HEIGHT}from"@wp/src/components/common/layoutManagers/bottomNavigator/constants";export const StyledBanner=styled(WpAlert)`
  &.ant-alert {
    align-items: center;
  }
  .ant-alert-content {
    flex: 55%;
  }
  .ant-alert-message {
    color: white;
    font-weight: 500;

    ${mediaQuery({textAlign:["center","left"]})}
  }

  .ant-alert-action {
    ${mediaQuery({width:["100%","fit-content"]})}
  }
`;export const topPriorityBannerStyles=props=>css`
  height: ${props.height}px;
  width: 100%;
`;export const TopPriorityBannersContainer=styled.div``;export const StyledFlexLayout=styled(FlexLayout)`
  gap: ${props=>props.isMobile?"10px":"32px"};
  height: ${props=>props.isMobile?"fit-content":"72px"};
  padding: ${props=>props.isMobile?"16px":"0"};
  border-color: ${props=>props.theme.colors.appBlue};
  bottom: ${props=>props.isMobile?BOTTOM_NAVIGATOR_HEIGHT:0}px;
  position: fixed;
  font-size: 16px;
`;export const StyledSignupButton=styled(Button)`
  background: ${props=>props.theme.colors.white};
  color: ${props=>props.theme.colors.appBlue};
  font-weight: 500;
  border-radius: 8px;
  width: ${props=>props.isMobile?"100%":"200px"};
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  gap: 8px;
  font-size: 16px;
`;export const MessageWrapper=styled.div`
  display: flex;
  align-items: center;
  font-size: ${props=>props.isMobile?"16px":"20px"};
  font-style: ${props=>props.theme.fontFamily};
  font-weight: 500;
  color: ${props=>props.theme.colors.white};
  gap: ${props=>props.isMobile?"0":"10px"};
`;